import React, { Component } from 'react';
import {
  View,
  ScrollView,
  StyleSheet,
  LayoutAnimation,
} from 'react-native';
import { translate } from 'react-i18next';
import {
  Heading, HeadingTypes, LoadingModal, UserDataConsumer,
} from 'fitbeat.react-native-components';

import NotificationCard from './NotificationCard';
import { GoogleAnalytics } from '../services/google-analytics';
import Theme from '../theme';
import { GymResolver } from '../services';

class NotificationsScreen extends Component {
  googleAnalytics = new GoogleAnalytics();

  constructor(props) {
    super(props);
    this.notificationManager = props.user.notifications.manager;
    const { userProfile } = props.user;
    const defaultGym = GymResolver.getByName(userProfile.gymName);
    const gymTimezone = defaultGym.timezone;

    this.state = {
      unreadCount: 0,
      notifications: [],
      isLoading: true,
      gymTimezone,
      closedNotifications: [],
      scrollEnabled: true,
    };
  }

  async componentDidMount() {
    this.googleAnalytics.setCurrentScreen('NotificationsScreen');
    await this.recalculate();
    await this.notificationManager.clearPushNotifications();
  }

  async componentWillUnmount() {
    await this.updateUnreadNotifications();
  }

  updateUnreadNotifications = async () => {
    const { closedNotifications } = this.state;
    const { user: { userProfile, userProfileService } } = this.props;

    if (userProfile.notifications && userProfile.notifications.length) {
      userProfile.notifications.map((notification) => {
        const isRead = closedNotifications.indexOf(notification.id) !== -1;
        if (isRead) {
          notification.read = true;
        }

        return notification;
      });
    }
    await userProfileService.updateUserProfile(userProfile);
  };

  recalculate = async () => {
    const unreadCount = this.notificationManager.getUnreadNotificationCountSync();
    const notifications = this.notificationManager.getNotificationsSync();

    const navParams = this.props.navigation.state.params || {};
    console.log('[NotificationsScreen] recalculate', navParams);

    await this.setState({
      unreadCount,
      notifications: notifications.filter((notification) => notification.read === false).reverse(),
      isLoading: false,
      navigationId: navParams.id,
    });
    console.log('[NotificationsScreen] recalculated', JSON.stringify(this.state));

    const { navigationId } = this.state;
    if (navigationId) {
      console.log('[NotificationsScreen] handling navigation notification id');
      const notification = notifications.find((n) => n.id === navigationId);
      this.setUnreadNotification(notification);
      this.notificationManager.handleNotificationById(this.state.navigationId, this.props.navigation.navigate);
      await this.markNotificationAsRead(notification);
    }
  };

  handleNotification = async (index, notification) => {
    this.onDismissNotification(index, notification);
    this.notificationManager.handleNotification(notification, this.props.navigation.navigate);
    await this.recalculate();
  };

  markNotificationAsRead = async (notification) => {
    const { user: { userProfileService: { markNotificationAsRead } } } = this.props;
    await markNotificationAsRead(notification.id);
  };

  shouldRender = ({ id }) => this.state.closedNotifications.indexOf(id) === -1;

  setScrollEnabled = (value) => {
    this.setState({ scrollEnabled: value });
  };

  onDismissNotification = async (index, notification) => {
    const { notifications } = this.state;
    const notificationCopy = [...notifications];

    this.setUnreadNotification(notification);

    if (notificationCopy.slice(index + 1, notifications.length).some(this.shouldRender)) {
      LayoutAnimation.configureNext(LayoutAnimation.Presets.spring);
    }

    this.debounce(async () => {
      await this.markNotificationAsRead(notification);
    }, 1000)();
  };

  setUnreadNotification = (notification) => {
    const { closedNotifications } = this.state;

    this.setState({
      closedNotifications: [...closedNotifications, notification.id],
    });
  };

  debounce = (fn, time) => {
    let timeout;

    const timeoutFn = () => {
      clearTimeout(timeout);
      timeout = setTimeout(fn, time);
    };

    return timeoutFn;
  };

  render() {
    const {
      isLoading,
      gymTimezone,
      notifications,
      closedNotifications,
    } = this.state;
    const { user: { userProfile } } = this.props;

    return (
      <ScrollView
        scrollEnabled={this.state.scrollEnabled}
        style={styles.container}
      >
        <LoadingModal isLoading={isLoading} />
        {notifications.map((notification, index) => this.shouldRender(notification) && (
        <View key={notification.id}>
          <NotificationCard
            userProfile={userProfile}
            gymTimezone={gymTimezone}
            notification={notification}
            setScrollEnabled={this.setScrollEnabled}
            handleNotification={(notification) => this.handleNotification(index, notification)}
            markNotificationAsRead={this.markNotificationAsRead}
            onDismissNotification={(notification) => this.onDismissNotification(index, notification)}
          />
        </View>
        ))}
        {((closedNotifications.length === notifications.length) || (notifications.length === 0))
          && (
          <Heading
            title={'You\'re all caught up!'}
            style={styles.emptyNotificationHeader}
            headingType={HeadingTypes.HEADING_TWO}
          />
          )}
      </ScrollView>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Theme.GREY_LIGHT,
  },
  emptyNotificationHeader: {
    textAlign: 'center',
    color: Theme.GREY_DARK,
  },
});

NotificationsScreen = UserDataConsumer(NotificationsScreen);
export default translate(['home'], { wait: true })(NotificationsScreen);
